import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSx = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-sx"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <clipPath id="sx-a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#sx-a)" transform="scale(.9375)">
      <path fill="#ed2939" fillRule="evenodd" d="M0 0h768v256H341.3z" />
      <path fill="#002395" fillRule="evenodd" d="M0 512h768V256H341.3z" />
      <path fill="#fff" fillRule="evenodd" d="m0 0 341.3 256L0 512z" />
      <path
        fill="#ff0"
        d="m172.3 193.2.1-4s-2.1-3.4.4-7c0 0-5.3-2.8-4-7.2 0 0-4.8-1.2-4.5-6.4 0 0-5-.3-5.6-4.7 0 0-5.1.8-7.4-3.4 0 0-5 1-6.4-2.5 0 0-4.9 1.6-7.7-2.5 0 0-5.2 2.1-7.3-1.8-2.1 3.9-7.3 1.8-7.3 1.8-2.8 4.1-7.7 2.4-7.7 2.4-1.4 3.5-6.3 2.5-6.3 2.5-2.3 4.3-7.4 3.4-7.4 3.4-.5 4.4-5.6 4.8-5.6 4.8a6 6 0 0 1-4.4 6.4c1.3 4.3-4 7.1-4 7.1 2.6 3.7.5 7 .5 7l-.1 3.7z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M377.2 843.1v-3.5s-1.8-3 .4-6c0 0-4.6-2.5-3.5-6.3 0 0-4.2-1-3.9-5.6 0 0-4.5-.3-5-4.1 0 0-4.4.7-6.3-3 0 0-4.4.8-5.6-2.2 0 0-4.3 1.5-6.8-2.1 0 0-4.5 1.8-6.3-1.6-1.9 3.4-6.4 1.6-6.4 1.6-2.4 3.5-6.7 2-6.7 2-1.2 3.1-5.5 2.3-5.5 2.3-2 3.7-6.5 3-6.5 3-.4 3.7-4.9 4-4.9 4a5 5 0 0 1-3.7 5.6c1 3.8-3.5 6.2-3.5 6.2 2.2 3.2.3 6.2.3 6.2v3.2z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="red"
        d="M170.3 188.2c-13.3-1.3-28.6-4.5-40.4 2.2-8-4.7-19-4.4-28.4-3.5-5.1 1-11.1 1-16.5 1.8l-.8.1c-9.7.7-18.5-2.2-27-6 2.8 15.2 5.7 30.7 7.2 46.6C67.6 253 53.3 272.7 59 296c3.5 11.2 15.8 17.7 27 19a215 215 0 0 1 32.2 4.5 32 32 0 0 1 5.5 1.9 20 20 0 0 1 6.6 4.7c6-6.3 15-8.1 23.7-9 15.8-1.9 35.3-.9 45-15.2v-.8c5.3-8 4.6-20 2.3-29-.2-3.1-1-5.9-1.5-8.9-9.6-25.5-1.3-54.2 2.8-80a61 61 0 0 1-16.4 5.5c-4.5.6-9.5.4-14 .1z"
      />
      <path
        fill="#80cfe1"
        d="M190.2 261.5c0 1.6.9 3 1.2 4.5 1.9 11.2 3.6 26-7.8 32.9-12.8 8-29.4 4.6-44.1 8.9-3 .8-7 3.5-9 5.4-1.4-.9-2.7-2.2-4.4-3-12.1-6.4-27.9-4.3-41.5-7.8-6.9-2.1-14-7.5-15.8-14.5-4.4-18.4 6.2-34.1 5-52.4-.8-14-3.2-27.3-6.4-40.4 10.7 5 23 5.8 35 3.4A52 52 0 0 1 130 201c4.6-2 10-2.9 15-3.4 9.3 1 19.4 2.6 29.1 2.6q9.7-.8 18-4.7c-3.3 21.6-9.8 44.2-1.9 66"
      />
      <path
        fill="#fff"
        d="M171 265.8v-20.4h2.4l-31-20-.1-10.5h3l-15.6-11-15.4 11h3v10.5l-30.9 20h2.5v20.3H171"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M376 906.5v-17.8h2.1l-27-17.5-.1-9h2.6l-13.6-9.8-13.5 9.7h2.6l.1 9.1-27 17.5h2.2v17.7z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#fff" d="M180.6 292.5v6.3H80.5v-6.4z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M384.4 929.8v5.5H297v-5.6h87.4z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#fff"
        d="M87.1 292.1v-21.5h4l-.2 21.7.2-21.6-5.8-.1v-4.7l89.4.2v4.5h-5.4v21.8l-.1-21.8h4l.2 21.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M302.8 929.4v-18.8h3.5l-.2 19 .2-18.8-5-.2v-4l78 .1v4h-4.8l.1 19-.2-19h3.6l.1 18.8"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M319.6 924.8v-13.1H309v13l10.5.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M312 914.4v7.6h4.8v-7.6h-4.9m59 10.4-.1-13h-10.4v13h10.5"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M363.2 914.5v7.6h4.8v-7.6h-4.8m7.6-11v-13h-10.5v13z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M363.1 893.2v7.6h4.8v-7.6h-4.8m-43.6 10.3v-13.1H309v13h10.5z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M311.9 893.1v7.6h4.8v-7.6h-4.8m26.6 10.4v-13.1H328v13h10.5"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M330.8 893.1v7.6h4.8v-7.6h-4.8m22.3 10.4v-13l-10.5-.1v13l10.5.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M345.4 893.1v7.6h4.9v-7.6h-4.9"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#fff" d="m147.7 257.8.2 34.6H113l-.1-34.6z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="m355.7 899.5.1 30.2h-30.3l-.1-30.2zm-30.5 8.6h30.6M329 929.7v-21.4m23.1 21.4v-21.3m14.7-21.8-17-12.4h-19.3l-17 12.4h53.3M332 863.8v7.6h16.2v-7.6H332"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M336.4 865.7v3.8h7.4v-3.8h-7.4M340 855l9 6.4h-17.9l9-6.4"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#fff"
        d="M171.4 202c2.9 0 3.6 12 3.6 18 2.6.8 8.1 4.3 10.6 7.4h-28.2c2.4-3.1 7.9-6.6 10.4-7.3 0-6 .6-18.2 3.6-18"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M376.3 850.8c2.6 0 3.2 10.5 3.2 15.8 2.2.6 7.1 3.7 9.2 6.4h-24.6c2.1-2.7 7-5.8 9.1-6.4 0-5.3.6-15.8 3.1-15.8m-49.5 49.5h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m4.5 0h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m5 0h2.1l-.6 1.2s1 1.4 0 3l.6 1h-2.1l.5-1s-1-1.8 0-3l-.6-1.2zm5.5 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2.1l.6-1s-1-1.8 0-3zm4.9 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1m4.9 0h2.2l-.7 1.2s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="M130.5 336.8c13 0 29-2.7 36.5-6.5l16.5-1.5.4 20.1c-14 7.7-46.2 9.4-53.3 9.3s-39.7-1.6-53.8-9.3l.2-20.2 16.5 1.5a98 98 0 0 0 37 6.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M340.7 968.4c11.4 0 25.3-2.3 31.9-5.7l14.3-1.2.3 17.5c-12.1 6.7-40.3 8.2-46.4 8.1s-34.7-1.4-47-8.2l.2-17.5 14.4 1.3c6.6 3.4 21 5.7 32.3 5.7"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="m34.4 251 14.5 4.6-4.4 23.5-13.7 2.2s-2.3-12.4 3.6-30.3"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="m256.9 893.6 12.6 4-3.8 20.5-12 1.9s-2-10.8 3.2-26.4z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#7e7e7e" d="m44.5 278.9-13.7 2.4 8.7-12.4z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="m265.7 917.9-12 2 7.6-10.7 4.4 8.7"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="m25.7 268 14 1c.3 11.8 1.8 57 55.8 59.5L93.8 345c-65.7.6-70.7-55.5-68-77"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="m249.3 908.4 12.2.8c.3 10.4 1.5 49.8 48.7 52l-1.5 14.4c-57.4.6-61.7-48.4-59.4-67.2zm44.8 70.1 14.4-3.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="m225.4 251.2-14.4 4.6 4.6 23.4 13.8 2.2s2.2-12.3-4-30.2"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="m423.5 893.7-12.6 4 4 20.5 12 2s2-10.8-3.4-26.5z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#7e7e7e" d="m215.6 279 13.7 2.5-8.8-12.4-5 9.9" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="m414.9 918 12 2.1-7.7-10.7-4.3 8.6"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="m234.3 268.1-14 1c-.2 11.8-1.3 57-55.3 59.5l2 16.4c65.7.8 70.2-55.4 67.4-76.9"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="m431.2 908.5-12.2.8c-.2 10.4-1 49.9-48.2 52l1.6 14.3c57.4.7 61.3-48.3 58.8-67zm-44.2 70-14.4-3"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#009fc5"
        d="M121.8 346.7q-.7.3-1.5.2l-2.6-.1.2-3.3 2.6.2q.8 0 1.2.3.7.3.7 1.4 0 .9-.7 1.3m-4.3 5 .2-3.9 3 .2q1.5.1 2.3-.7.8-.6.8-1.8a3 3 0 0 0-.6-2 3 3 0 0 0-2-.9l-4.4-.3-.6 9.4zm9.4-7.7h3.2l1.1.2q.7.4.7 1.4t-.5 1.3l-1.4.3h-3.1zm0 8.2v-4l3 .1q.8 0 1.2.2.7.3.7 1.2v2.3l.2.3h1.6v-.2l-.4-.5-.1-.8v-1.3q0-.9-.4-1.2l-.8-.6q.7-.3 1-.8t.4-1.4q0-1.6-1.4-2.2l-1.8-.4h-4.5v9.4zm10-2a5 5 0 0 1-1-2.6q0-2 .8-3a3 3 0 0 1 2.4-1 3 3 0 0 1 2.4.8q1 1 1.1 2.6a5 5 0 0 1-.6 2.8q-.7 1.3-2.5 1.3c-1.8 0-2-.2-2.7-.9m-1.5-5.9a6 6 0 0 0-.8 3.3q.1 2.1 1.4 3.4a5 5 0 0 0 3.6 1.3 4 4 0 0 0 3.5-1.8 6 6 0 0 0 1-3.6 5 5 0 0 0-1.2-3.1q-1.3-1.5-3.9-1.4-2.4 0-3.6 1.9m44-13.5q1.5-.2 2.5.1 1.5.5 2.2 2.3l-1.3.2a2 2 0 0 0-1.2-1.3 4 4 0 0 0-2-.2 3 3 0 0 0-2 1.3q-.8 1-.5 3a5 5 0 0 0 1.2 2.6q1 .9 2.6.7a3 3 0 0 0 2-1.1q.8-.9.5-2.5l-3 .5-.1-1 4.2-.7.8 5h-.9l-.5-1-1 1q-.8.7-2 .9a4 4 0 0 1-3.2-.7 5 5 0 0 1-1.9-3.4 5 5 0 0 1 .7-4 4 4 0 0 1 3-1.7m9.4-.7 3-1.1 1.1-.2q.9 0 1.2 1t0 1.5q-.4.5-1.3.8l-2.8 1zm3 7.7-1.4-3.7 2.8-1 1.1-.3q.8.1 1.2 1l.6 1.4.3.7.2.3 1.5-.6v-.2q-.5 0-.6-.4-.3-.2-.4-.7l-.5-1.2q-.3-.7-.7-1l-1-.2.6-1.2-.2-1.4q-.6-1.6-2-1.6l-1.9.3-4.2 1.5 3.4 8.8 1.2-.4m11-4.7-5.3-7.8 5.8-3.8.7 1-4.8 3 1.6 2.4 4.5-2.8.6.9-4.5 2.8 1.8 2.7 5-3.2.6 1zm4.7-13.8 1.5-1.7q1.2-1.2 2.3-1 1.3 0 2.6 1.3a5 5 0 0 1 1.4 2q.2.9 0 1.6l-.7 1-1.5 1.6zm8.1 3.6q1.6-1.7.7-4a7 7 0 0 0-1.7-2.1 5 5 0 0 0-3.1-1.4q-1.8-.2-3.1 1.3l-2.6 2.8 7.2 6.3 2.6-2.8m5.6-7.3-8.3-5 .7-1 8.3 4.9zm3.3-5.6-9-3.6 2.6-6.3 1.1.4-2.1 5.2 2.7 1 2-4.7 1 .4-2 4.8 3 1.2 2.3-5.2 1 .4zm4-11-9.4-2 .4-1.5 8.7-3-7.7-1.7.3-1.1 9.4 2-.3 1.4-8.7 3 7.7 1.7zm-.8-12 .1-1.2q.8 0 1.4-.2 1-.6 1.2-2.1l-.1-1.4q-.3-1.1-1.3-1.2t-1.2.3q-.4.4-.7 1.5l-.5 1.2q-.3 1.2-.8 1.7-.6.9-1.8.7a3 3 0 0 1-2-1q-.9-1-.7-2.6.1-1.5 1-2.4.8-1 2.4-.8l-.1 1.2q-.8 0-1.2.3-.9.5-1 1.9-.1 1 .4 1.6t1 .6q.8.1 1.1-.4l.7-1.7.4-1.3q.3-.9.8-1.4.8-.7 2-.7 1.7.2 2.2 1.4t.5 2.7a4 4 0 0 1-1.2 2.6q-1 .9-2.6.7M32 286.7l.3 1.2q-.9.1-1.3.6-.8.8-.5 2.4l.4 1.2q.6 1 1.7.9.7-.1 1-.7l.3-1.6v-1.3q0-1.3.3-1.8.5-.9 1.7-1.2 1.3-.2 2.2.6 1 .6 1.3 2.2a4 4 0 0 1-.3 2.6q-.5 1.1-2.1 1.4l-.2-1.1 1-.6q.7-.7.5-2.1-.2-1.2-.8-1.5l-1.2-.3a1 1 0 0 0-1 .7l-.1 1.8-.1 1.3-.4 1.6a2 2 0 0 1-1.7 1.2q-1.6.3-2.5-.8a5 5 0 0 1-1.2-2.4 4 4 0 0 1 .5-2.9 3 3 0 0 1 2.2-1.3m-.6 12.3 9.3-2.8 2.1 6.5-1.1.4-1.8-5.3-2.8.8 1.7 5-1.1.3-1.6-5-3.2 1 1.8 5.4-1 .3zm4.1 11.3 8.5-4.5 1 1.6-5.9 6.1 8.5-1.4.9 1.5-8.5 4.5-.6-1 5-2.7.9-.4 1.3-.7-8.5 1.5-.6-1.1 5.8-6.2-.3.2-1 .5-.9.5-5 2.6zm15.8 12.5q-.6-.2-1.2-.8l-1.8-1.8 2.4-2.2 1.8 1.8.7 1q.3.8-.5 1.5t-1.4.5m-6.8.8 3-2.7 2 2.1q1.2 1 2.2 1a3 3 0 0 0 2-.8 3 3 0 0 0 .8-2q0-1-.9-1.9l-3-3-7 6.4zm8.4 7.5 5.1-8 6 3.6-.6 1-5-3-1.5 2.5 4.5 2.7-.5 1-4.6-2.8-1.7 2.7 5 3-.6 1zm15-1.6 3.1 1 1 .5q.6.6.2 1.5-.2 1-.9 1.1l-1.5-.1-2.9-1zm-2.6 7.9 1.3-3.8 2.8.9q.8.2 1.1.5.5.5.3 1.4l-.5 1.5-.1.7v.3l1.5.5v-.2l-.2-.7.2-.7.4-1.2q.2-.9 0-1.2 0-.5-.6-.9.8 0 1.3-.5t.7-1.2q.6-1.5-.6-2.5l-1.6-.9-4.3-1.3-3 8.9z"
      />
      <path
        fill="#bc715f"
        d="M78.5 175.6c1-2.7 11.3-10 44.8-6.8 0 0 5.7 3.5 9 3 2-.2-1 .2-3.6-1.9-2.5-2-3-6.3 2.7-6.1 5.8.1 27.3 1.3 27.7 3.3s-11.4 2.7-15.7 2.6c-4.4-.1-4 2.1.4 2 13.7-.6 28.6-5.4 44.3 5.8 1.9 1.3-4.7 1.5-9.8-.6 0 0-14 .7-20-.3 0 0-4.5 3.8-10.6 3.4.8 2-2.2 9.2-21 3.7-3.2 1-14.5 2.9-13.3-.5-3 0-8.2 1-9-.7s9.2-4.2 11-6c0 0-21.2.2-25.2-1.3 0 0-12.5 2.8-11.7.4"
      />
      <path
        fill="#008737"
        d="M85.3 205.2c.4-.6.6-1.8 1.6-1.7 2 .5 3.5 4.4 6 1.9 1-.2 1.3 1 2 1.2.5 2.1 2.3-.5 3.5-.3q4.3-1.8 9.4-1c0 2.2-1.6 4.5-3.6 5.7 0 2 2 3.4 1.9 5.5-.3.8 0 2-1.2 2.3-1.6-.3-3-.4-4.3-1.3q-.2-.3-.6-.3c-.2.7 1 1.4 1.4 2.1-.8 1.3-2 .1-3.1.1-.3.8 0 1.7-.8 2.2-1.3 0-1.6-1.5-2.4-2.2-.9.9.6 1.4.8 2.1-.6 2.8-.5 5.5-3.2 7.3l-1.9.9c-.5-1.4-.2-3.5-.5-5q-1.4 2.7-3.5 4.9c-2-.6-3-2.8-3.4-4.7a6 6 0 0 1 1.3-6.2c-.5-1-2.5-.8-2.8-2.4-3-2-4.5 3.3-6.4.6a9 9 0 0 1 2-7.6c-.5-1-1.9-.8-2.7-1.4-1.8-1.6-4.5-3.2-4.3-6a14 14 0 0 1 14.7 3.3"
      />
      <path
        fill="#ff0"
        d="M87.9 204.9c-.1 2.3 1.5.6 2.8 2-1-.4-1.7 1.7-2.7.5l-.6.6c.4.8 1 .9.4 1.8-1 .4-1.3-1-1.8-1.5q.2-.4-.2-.8-.8.7-2 .6c-.2-.4-.7-1-.2-1.4.8-1 2 .4 2.6-.3.1-.7-.5-1.5.3-2 .5.1 1.2-.2 1.4.5m6.2 1.9c.1.4-.2 1 .4 1.4q1.3-.5 2 .6.2.8-.4 1.2l-1.2-.3q0-.2-.4-.6-.8 0-1.2.6c.3.4 1 .7.8 1.2-.7.7-1-.6-1.8-.2-.6-.2.1-1.3-.7-1.7-1 0-.3 1.6-1.6 1q-.8-.8-.4-1.7a2 2 0 0 1 1.9.2c.8-.9.8-4.1 2.7-1.7m-7.8 3.3c.5.8-.2 1.8.5 2.6 1-2 2 .4 3.2.2.4.5.1 1.1.2 1.6-1.5.4-3.3.9-4.6-.3l-.4.4c.8.7 1.5 1.6.9 2.8-1.1.2-2.9.3-3.4-.9-.3-1 .7-1.6-.4-2.4-.7 1-.7 2.2-2.2 1.3a2 2 0 0 1-.8-2.5c1-1.6 2.8 0 3.8-.7.2-1.4-.3-2.6 1-3.3 1-.2 1.5.6 2.2 1.2"
      />
      <path
        fill="#fff"
        d="M90.6 211c-.5 2.3-2.2-.1-3-.2 1-2 1.7.6 3 .2m5.4 2.5c-1.2.3-1-1.2-1.6-1.8l.5-.4z"
      />
      <path
        fill="#ff0"
        d="M94.4 213c.3.8-.8 1.5.2 2l.8-.7q1.4.1 2.4 1.2c.6 1.7-1.1 1.7-2 2.2h-1c.2-.6-.5-.8-.6-1a1 1 0 0 0-1.1.3c.2 1 1.5 2 .2 2.9-1.2 0-3 .4-2.9-1.2-.4-1 1.2-2.3-.5-2.4-.6 1.3-1.2 2.4-2.7 1.3l.2-1.8c1.4 0 3.1.3 3.7-1.3.4-1.1-.7-2.2.3-3 1.5-.4 2.3.6 3 1.5"
      />
      <path d="M93.4 215.6c.3.9-.6 1-1.1 1.4q-.8 0-1.4-.6c-.3-1 .5-1.2 1-1.6.7-.3 1 .5 1.5.8" />
      <path fill="#fff" d="M92.5 216.2q-.2.2-.6.2l-.2-1q1-.1.8.8" />
    </g>
  </svg>
);
export default SvgSx;
